import React from 'react';
import { ShieldCheck, Clock, X } from 'lucide-react';

/**
 * Slim, high-contrast trust bar that sits directly under the Navbar.
 * Designed to immediately answer the #1 unspoken objection IG visitors
 * have: "is this going to charge my card right away?"
 *
 * Reinforced with: 7-day free trial · cancel anytime · UK-compliant.
 * Includes a tiny close (×) so returning visitors aren't nagged.
 */
const STORAGE_KEY = 'mbap_trust_bar_dismissed';

const TrustBar = () => {
  const [dismissed, setDismissed] = React.useState(() => {
    try { return !!localStorage.getItem(STORAGE_KEY); } catch { return false; }
  });
  if (dismissed) return null;
  const close = () => {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch { /* ignore */ }
    setDismissed(true);
  };
  return (
    <div
      className="bg-gradient-to-r from-orange-500 via-rose-500 to-amber-500 text-white text-sm relative"
      data-testid="trust-bar"
      role="region"
      aria-label="Free trial offer"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-2.5 flex items-center justify-center gap-3 flex-wrap text-center">
        <span className="font-semibold">7-day free trial</span>
        <span className="hidden sm:inline opacity-70">·</span>
        <span className="hidden sm:inline-flex items-center gap-1">
          <Clock className="w-3.5 h-3.5" /> Cancel anytime
        </span>
        <span className="hidden sm:inline opacity-70">·</span>
        <span className="hidden sm:inline-flex items-center gap-1">
          <ShieldCheck className="w-3.5 h-3.5" /> UK ASA-compliant
        </span>
        <span className="sm:hidden text-xs opacity-95">Cancel anytime · UK compliant</span>
      </div>
      <button
        onClick={close}
        aria-label="Dismiss"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-full hover:bg-white/15"
        data-testid="trust-bar-close"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default TrustBar;
